function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t), t = setTimeout(() => fn.apply(this, args), wait)
    }
}
class FacetFiltersForm extends HTMLElement {
    constructor() {
        super(), this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
        const form = this.querySelector("form");
        if (form && form.dataset.fallbackFilters === "true") {
            window.__collectionFallbackFiltersBooted || (window.__collectionFallbackFiltersBooted = !0, window.setTimeout(() => {
                CollectionFallbackFilters.init()
            }, 0));
            return
        }
        this.debouncedOnSubmit = debounce(event => {
            this.onSubmitHandler(event)
        }, 800), form.addEventListener("input", this.debouncedOnSubmit.bind(this));
        const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
        facetWrapper && facetWrapper.addEventListener("keyup", onKeyUpEscape)
    }
    static setListeners() {
        const onHistoryChange = event => {
            if (document.getElementById("main-collection-filters") && document.getElementById("main-collection-filters").dataset.fallbackFilters === "true") return;
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
            searchParams !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(searchParams, null, !1)
        };
        window.addEventListener("popstate", onHistoryChange)
    }
    static toggleActiveFacets(disable = !0) {
        document.querySelectorAll(".js-facet-remove").forEach(element => {
            element.classList.toggle("disabled", disable)
        })
    }
    static renderPage(searchParams, event, updateURLHash = !0) {
        if (document.getElementById("main-collection-filters") && document.getElementById("main-collection-filters").dataset.fallbackFilters === "true") return;
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections(),
            countContainer = document.getElementById("ProductCount"),
            countContainerDesktop = document.getElementById("ProductCountDesktop");
        document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner").forEach(spinner => spinner.classList.remove("hidden")), countContainer && countContainer.classList.add("loading"), countContainerDesktop && countContainerDesktop.classList.add("loading"), sections.forEach(section => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`,
                filterDataUrl = element => element.url === url;
            FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event)
        }), updateURLHash && FacetFiltersForm.updateURLHash(searchParams)
    }
    static renderSectionFromFetch(url, event) {
        fetch(url).then(response => response.text()).then(responseText => {
            const html = responseText;
            FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
                html,
                url
            }], FacetFiltersForm.renderFilters(html, event), FacetFiltersForm.renderProductGridContainer(html), FacetFiltersForm.renderProductCount(html), addToCart.addEventListener(), cardProduct.addEventListener(), drawerController.eventListeners(), typeof initializeScrollAnimationTrigger == "function" && initializeScrollAnimationTrigger(html.innerHTML)
        })
    }
    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
        FacetFiltersForm.renderFilters(html, event), FacetFiltersForm.renderProductGridContainer(html), FacetFiltersForm.renderProductCount(html), typeof initializeScrollAnimationTrigger == "function" && initializeScrollAnimationTrigger(html.innerHTML)
    }
    static renderProductGridContainer(html) {
        document.getElementById("ProductGridContainer").innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("ProductGridContainer").innerHTML, document.getElementById("ProductGridContainer").querySelectorAll(".scroll-trigger").forEach(element => {
            element.classList.add("scroll-trigger--cancel")
        })
    }
    static renderProductCount(html) {
        const count = new DOMParser().parseFromString(html, "text/html").getElementById("ProductCount").innerHTML,
            container = document.getElementById("ProductCount"),
            containerDesktop = document.getElementById("ProductCountDesktop");
        container.innerHTML = count, containerDesktop && (containerDesktop.innerHTML = count, containerDesktop.classList.remove("loading")), document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner").forEach(spinner => spinner.classList.add("hidden"))
    }
    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html"),
            facetDetailsElementsFromFetch = parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"),
            facetDetailsElementsFromDom = document.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter");
        Array.from(facetDetailsElementsFromDom).forEach(currentElement => {
            Array.from(facetDetailsElementsFromFetch).some(({
                id
            }) => currentElement.id === id) || currentElement.remove()
        });
        const matchesId = element => {
                const jsFilter = event ? event.target.closest(".js-filter") : void 0;
                return jsFilter ? element.id === jsFilter.id : !1
            },
            facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(element => !matchesId(element)),
            countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);
        if (facetsToRender.forEach((elementToRender, index) => {
                if (document.getElementById(elementToRender.id)) document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
                else {
                    if (index > 0) {
                        const {
                            className: previousElementClassName,
                            id: previousElementId
                        } = facetsToRender[index - 1];
                        if (elementToRender.className === previousElementClassName) {
                            document.getElementById(previousElementId).after(elementToRender);
                            return
                        }
                    }
                    elementToRender.parentElement && document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender)
                }
            }), FacetFiltersForm.renderActiveFacets(parsedHTML), countsToRender) {
            const closestJSFilterID = event.target.closest(".js-filter").id;
            if (closestJSFilterID) {
                FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter")), FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));
                const newFacetDetailsElement = document.getElementById(closestJSFilterID),
                    newElementSelector = newFacetDetailsElement.classList.contains("mobile-facets__details") ? ".mobile-facets__close-button" : ".facets__summary",
                    newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector),
                    isTextInput = event.target.getAttribute("type") === "text";
                newElementToActivate && !isTextInput && newElementToActivate.focus()
            }
        }
    }
    static renderActiveFacets(html) {
        [".active-facets-mobile", ".active-facets-desktop"].forEach(selector => {
            const activeFacetsElement = html.querySelector(selector);
            activeFacetsElement && (document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML)
        }), FacetFiltersForm.toggleActiveFacets(!1)
    }
    static renderAdditionalElements(html) {
        [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach(selector => {
            html.querySelector(selector) && (document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML)
        }), document.getElementById("FacetFiltersFormMobile").closest("menu-drawer").bindEvents()
    }
    static renderCounts(source, target) {
        const targetSummary = target.querySelector(".facets__summary"),
            sourceSummary = source.querySelector(".facets__summary");
        sourceSummary && targetSummary && (targetSummary.outerHTML = sourceSummary.outerHTML);
        const targetHeaderElement = target.querySelector(".facets__header"),
            sourceHeaderElement = source.querySelector(".facets__header");
        sourceHeaderElement && targetHeaderElement && (targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML);
        const targetWrapElement = target.querySelector(".facets-wrap"),
            sourceWrapElement = source.querySelector(".facets-wrap");
        sourceWrapElement && targetWrapElement && (target.querySelector("show-more-button .label-show-more.hidden") && sourceWrapElement.querySelectorAll(".facets__item.hidden").forEach(hiddenItem => hiddenItem.classList.replace("hidden", "show-more-item")), targetWrapElement.outerHTML = sourceWrapElement.outerHTML)
    }
    static renderMobileCounts(source, target) {
        const targetFacetsList = target.querySelector(".mobile-facets__list"),
            sourceFacetsList = source.querySelector(".mobile-facets__list");
        sourceFacetsList && targetFacetsList && (targetFacetsList.outerHTML = sourceFacetsList.outerHTML)
    }
    static updateURLHash(searchParams) {
        history.pushState({
            searchParams
        }, "", `${window.location.pathname}${searchParams&&"?".concat(searchParams)}`)
    }
    static getSections() {
        return [{
            section: document.getElementById("product-grid").dataset.id
        }]
    }
    createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString()
    }
    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event)
    }
    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll("facet-filters-form form");
        if (event.srcElement.className == "mobile-facets__checkbox") {
            const searchParams = this.createSearchParams(event.target.closest("form"));
            this.onSubmitForm(searchParams, event)
        } else {
            const forms = [],
                isMobile = event.target.closest("form").id === "FacetFiltersFormMobile";
            sortFilterForms.forEach(form => {
                isMobile ? form.id === "FacetFiltersFormMobile" && forms.push(this.createSearchParams(form)) : (form.id === "FacetSortForm" || form.id === "FacetFiltersForm" || form.id === "FacetSortDrawerForm") && forms.push(this.createSearchParams(form))
            }), this.onSubmitForm(forms.join("&"), event)
        }
    }
    onActiveFilterClick(event) {
        event.preventDefault(), FacetFiltersForm.toggleActiveFacets();
        const url = event.currentTarget.href.indexOf("?") == -1 ? "" : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
        FacetFiltersForm.renderPage(url)
    }
}
FacetFiltersForm.filterData = [], FacetFiltersForm.searchParamsInitial = window.location.search.slice(1), FacetFiltersForm.searchParamsPrev = window.location.search.slice(1), customElements.define("facet-filters-form", FacetFiltersForm), FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
    constructor() {
        super(), this.querySelectorAll("input").forEach(element => {
            element.addEventListener("change", this.onRangeChange.bind(this)), element.addEventListener("keydown", this.onKeyDown.bind(this))
        }), this.setMinAndMaxValues()
    }
    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget), this.setMinAndMaxValues()
    }
    onKeyDown(event) {
        if (event.metaKey) return;
        const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
        event.key.match(pattern) || event.preventDefault()
    }
    setMinAndMaxValues() {
        const inputs = this.querySelectorAll("input"),
            minInput = inputs[0],
            maxInput = inputs[1];
        maxInput.value && minInput.setAttribute("data-max", maxInput.value), minInput.value && maxInput.setAttribute("data-min", minInput.value), minInput.value === "" && maxInput.setAttribute("data-min", 0), maxInput.value === "" && minInput.setAttribute("data-max", maxInput.getAttribute("data-max"))
    }
    adjustToValidValues(input) {
        const value = Number(input.value),
            min = Number(input.getAttribute("data-min")),
            max = Number(input.getAttribute("data-max"));
        value < min && (input.value = min), value > max && (input.value = max)
    }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector("a");
        facetLink.setAttribute("role", "button"), facetLink.addEventListener("click", this.closeFilter.bind(this)), facetLink.addEventListener("keyup", event => {
            event.preventDefault(), event.code.toUpperCase() === "SPACE" && this.closeFilter(event)
        })
    }
    closeFilter(event) {
        event.preventDefault(), (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(event)
    }
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;
    const summaryElement = openDetailsElement.querySelector("summary");
    openDetailsElement.removeAttribute("open"), summaryElement.setAttribute("aria-expanded", !1), summaryElement.focus()
}
customElements.define("facet-remove", FacetRemove);
class filterLabelContainer {
    constructor() {
        this.onClick = this.onClick.bind(this), document.addEventListener("click", this.onClick), this.ensureInitialState()
    }
    getFilters() {
        return Array.from(document.querySelectorAll("#main-collection-filters .mobile-facets__options-container [data-filter]"))
    }
    getPanels() {
        return Array.from(document.querySelectorAll("#main-collection-filters .facets__brand-container > .mobile-facets__submenu"))
    }
    ensureInitialState() {
        const activeFilter = this.getFilters().find(item => item.classList.contains("active"));
        if (activeFilter) {
            this.toggleFilter(activeFilter);
            return
        }
        const firstFilter = this.getFilters()[0];
        firstFilter && this.toggleFilter(firstFilter)
    }
    onClick(event) {
        const filter = event.target.closest("#main-collection-filters .mobile-facets__options-container [data-filter]");
        filter && (event.preventDefault(), this.toggleFilter(filter))
    }
    toggleFilter(item) {
        this.getFilters().forEach(item2 => {
            item2.classList.remove("active")
        }), this.getFilters().filter(item2 => item2.dataset.filter === item.dataset.filter).forEach(item2 => {
            item2.classList.add("active")
        }), this.getPanels().forEach(item2 => item2.classList.remove("show"));
        const targetPanel = document.querySelector(`#${item.dataset.filter}filter`);
        targetPanel && targetPanel.classList.add("show")
    }
}
const FilterLabelContainer = new filterLabelContainer;
class CollectionFallbackFilters {
    constructor(root) {
        this.root = root, this.collectionUrl = root.dataset.collectionUrl || window.location.pathname, this.productGrid = document.getElementById("product-grid"), this.pagination = document.querySelector(".product-grid--pagination"), this.sortSelects = Array.from(document.querySelectorAll('select[name="sort_by"]')), this.desktopCounts = Array.from(document.querySelectorAll("#ProductCountDesktop")), this.mobileCounts = Array.from(document.querySelectorAll("#ProductCount")), this.activeFacetLinks = Array.from(document.querySelectorAll(".active-facets__button-remove, .facets__reset, .mobile-facets__clear")), this.pageSize = this.getPageSize(), this.visibleCount = this.pageSize, this.filteredProducts = [], this.desktopLists = {
            brand: document.querySelector('[id^="Details-filter.p.vendor-"] .facets__list'),
            flavour: document.querySelector('[id^="Details-filter.p.m.custom.flavour-"] .facets__list'),
            strength: document.querySelector('[id^="Details-filter.v.m.strength.tier-"] .facets__list'),
            type: document.querySelector('[id^="Details-filter.p.product_type-"] .facets__list')
        }, this.mobileLists = {
            brand: document.querySelector("#brandfilter .mobile-facets__list"),
            flavour: document.querySelector("#flavourfilter .mobile-facets__list"),
            strength: document.querySelector("#strengthfilter .mobile-facets__list"),
            type: document.querySelector("#typefilter .mobile-facets__list")
        }, this.summaries = {
            brand: document.querySelector('[id^="Details-filter.p.vendor-"] .facets__summary'),
            flavour: document.querySelector('[id^="Details-filter.p.m.custom.flavour-"] .facets__summary'),
            strength: document.querySelector('[id^="Details-filter.v.m.strength.tier-"] .facets__summary'),
            type: document.querySelector('[id^="Details-filter.p.product_type-"] .facets__summary')
        }, this.headers = {
            brand: document.querySelector('[id^="Facet-1-"] .facets__selected'),
            flavour: document.querySelector('[id^="Facet-2-"] .facets__selected'),
            strength: document.querySelector('[id^="Facet-3-"] .facets__selected'),
            type: document.querySelector('[id^="Facet-4-"] .facets__selected')
        }, this.state = {
            brand: [],
            flavour: [],
            strength: [],
            type: [],
            sortBy: this.sortSelects[0] ? this.sortSelects[0].value : "title-ascending"
        }, this.products = [], this.typeOptions = [], this.moneyFormatter = new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: "GBP"
        }), this.handleSortChange = this.handleSortChange.bind(this), this.handleCheckboxChange = this.handleCheckboxChange.bind(this), this.handleResetClick = this.handleResetClick.bind(this), this.handlePopState = this.handlePopState.bind(this), this.handleLoadMoreClick = this.handleLoadMoreClick.bind(this), this.loadProducts().then(() => {
            this.typeOptions = this.buildTypeOptions(), this.renderFilterLists(), this.syncStateFromUrl(), this.bindEvents(), this.applyFilters(!0)
        }).catch(error => {
            console.error("Fallback filters failed to initialize", error)
        })
    }
    static init() {
        const root = document.getElementById("main-collection-filters");
        return !root || root.dataset.fallbackFilters !== "true" ? null : CollectionFallbackFilters.instance || (CollectionFallbackFilters.instance = new CollectionFallbackFilters(root))
    }
    async loadProducts() {
        const products = [];
        for (let page = 1; page <= 10; page += 1) {
            const response = await fetch(`${this.collectionUrl}/products.json?limit=250&page=${page}`),
                data = await response.json(),
                pageProducts = data.products || [];
            if (!pageProducts.length) break;
            products.push(...pageProducts.map((product, index) => this.parseProduct(product, products.length + index))), pageProducts.length < 250 && (page = 11)
        }
        this.products = products
    }
    parseProduct(product, featuredOrder) {
        const primaryVariant = product.variants.find(variant => variant.available) || product.variants[0] || {},
            image = primaryVariant.featured_image && primaryVariant.featured_image.src ? primaryVariant.featured_image.src : product.images && product.images[0] ? product.images[0].src : "",
            strengthValues = product.variants.flatMap(variant => [variant.option1, variant.option2, variant.option3].filter(Boolean)),
            productTags = this.normalizeTags(product.tags),
            offerLabel = this.resolveOfferLabel(productTags),
            variantStrengths = Array.from(new Set(strengthValues.map(value => this.extractStrengthLabel(value)).filter(Boolean))),
            strengthTiers = Array.from(new Set(strengthValues.map(value => this.mapStrengthTier(value)).filter(Boolean))),
            flavour = this.extractFlavour(product),
            compareAtPrice = parseFloat(primaryVariant.compare_at_price || primaryVariant.price || 0),
            price = parseFloat(primaryVariant.price || 0);
        return {
            createdAt: Date.parse(product.created_at || product.published_at || "") || 0,
            featuredOrder,
            flavour,
            handle: product.handle,
            image,
            labelClass: offerLabel.className,
            labelText: offerLabel.text,
            price,
            compareAtPrice,
            productType: product.product_type || "",
            strengthTiers,
            tags: productTags,
            title: product.title,
            url: `/products/${product.handle}`,
            variantStrengths,
            vendor: product.vendor || ""
        }
    }
    renderFilterLists() {
        this.renderDesktopList("brand", CollectionFallbackFilters.brandOptions), this.renderDesktopList("flavour", CollectionFallbackFilters.flavourOptions), this.renderDesktopList("strength", CollectionFallbackFilters.strengthOptions), this.renderDesktopList("type", this.typeOptions), this.renderMobileList("brand", CollectionFallbackFilters.brandOptions), this.renderMobileList("flavour", CollectionFallbackFilters.flavourOptions), this.renderMobileList("strength", CollectionFallbackFilters.strengthOptions), this.renderMobileList("type", this.typeOptions), this.syncInputs()
    }
    renderDesktopList(key, options) {
        const list = this.desktopLists[key];
        list && (list.innerHTML = options.map((option, index) => `<li class="list-menu__item facets__item"><label for="Fallback-${key}-${index + 1}" class="facets__label facet-checkbox"><input type="checkbox" data-fallback-filter="${key}" value="${this.escapeHtml(option)}" id="Fallback-${key}-${index + 1}"><svg width="16px" height="16px" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><rect width="16" height="16" stroke="currentColor" fill="none" stroke-width="1"></rect></svg><svg aria-hidden="true" class="icon icon-checkmark" width="1.1rem" height="0.7rem" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 3.5L2.83333 4.75L4.16667 6L9.5 1" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"></path></svg><span class="facet-checkbox__text" aria-hidden="true"><span class="facet-checkbox__text-label">${this.escapeHtml(option)}</span></span></label></li>`).join(""))
    }
    renderMobileList(key, options) {
        const list = this.mobileLists[key];
        list && (list.innerHTML = options.map((option, index) => `<li class="mobile-facets__item list-menu__item"><label for="Fallback-${key}-mobile-${index + 1}" class="facets__label mobile-facets__label"><input class="mobile-facets__checkbox" type="checkbox" data-fallback-filter="${key}" value="${this.escapeHtml(option)}" id="Fallback-${key}-mobile-${index + 1}"><span class="mobile-facets__highlight"></span><span class="facet-checkbox__text" aria-hidden="true"><span class="facet-checkbox__text-label">${this.escapeHtml(option)}</span></span></label></li>`).join(""))
    }
    bindEvents() {
        document.querySelectorAll("[data-fallback-filter]").forEach(input => {
            input.addEventListener("change", this.handleCheckboxChange)
        }), this.sortSelects.forEach(select => {
            select.addEventListener("change", this.handleSortChange)
        }), this.activeFacetLinks.forEach(link => {
            link.addEventListener("click", this.handleResetClick, !0)
        }), this.pagination && this.pagination.addEventListener("click", this.handleLoadMoreClick), window.addEventListener("popstate", this.handlePopState)
    }
    handleCheckboxChange(event) {
        const input = event.target,
            filterKey = input.dataset.fallbackFilter;
        filterKey && (event.stopPropagation(), this.state[filterKey] = Array.from(document.querySelectorAll(`[data-fallback-filter="${filterKey}"]:checked`)).map(checkbox => checkbox.value).filter((value, index, values) => values.indexOf(value) === index), this.applyFilters())
    }
    handleSortChange(event) {
        this.state.sortBy = event.target.value, this.sortSelects.forEach(select => {
            select !== event.target && (select.value = this.state.sortBy)
        }), this.applyFilters()
    }
    handleResetClick(event) {
        const link = event.currentTarget;
        if (!link.closest("#main-collection-filters")) return;
        event.preventDefault(), event.stopImmediatePropagation();
        const detail = link.closest("details"),
            matchedKey = detail && detail.id.indexOf("filter.p.vendor") !== -1 ? "brand" : detail && detail.id.indexOf("filter.p.m.custom.flavour") !== -1 ? "flavour" : detail && detail.id.indexOf("filter.v.m.strength.tier") !== -1 ? "strength" : detail && detail.id.indexOf("filter.p.product_type") !== -1 ? "type" : null;
        matchedKey ? this.state[matchedKey] = [] : (this.state.brand = [], this.state.flavour = [], this.state.strength = [], this.state.type = []), this.applyFilters()
    }
    handlePopState() {
        this.syncStateFromUrl(), this.applyFilters(!0)
    }
    handleLoadMoreClick(event) {
        const button = event.target.closest("[data-fallback-load-more]");
        button && (event.preventDefault(), this.visibleCount += this.pageSize, this.renderProducts(this.filteredProducts))
    }
    syncStateFromUrl() {
        const params = new URLSearchParams(window.location.search);
        this.state.brand = params.getAll("pf_brand"), this.state.flavour = params.getAll("pf_flavour"), this.state.strength = params.getAll("pf_strength"), this.state.type = params.getAll("pf_type"), params.get("sort_by") && (this.state.sortBy = params.get("sort_by")), this.syncInputs()
    }
    syncInputs() {
        document.querySelectorAll("[data-fallback-filter]").forEach(input => {
            const key = input.dataset.fallbackFilter;
            input.checked = this.state[key].includes(input.value)
        }), this.sortSelects.forEach(select => {
            select.value = this.state.sortBy
        }), this.updateSummaryStates()
    }
    applyFilters(replaceState = !1) {
        const filteredProducts = this.sortProducts(this.products.filter(product => this.matchesFilters(product)));
        this.visibleCount = this.pageSize, this.renderProducts(filteredProducts), this.updateCounts(filteredProducts.length), this.updateSummaryStates(), this.updateUrl(replaceState)
    }
    matchesFilters(product) {
        return (!this.state.brand.length || this.state.brand.includes(product.vendor)) && (!this.state.flavour.length || this.state.flavour.includes(product.flavour)) && (!this.state.strength.length || product.strengthTiers.some(tier => this.state.strength.includes(tier))) && (!this.state.type.length || this.state.type.includes(product.productType))
    }
    sortProducts(products) {
        const sorted = [...products];
        return sorted.sort((productA, productB) => {
            switch (this.state.sortBy) {
                case "title-ascending":
                    return productA.title.localeCompare(productB.title);
                case "title-descending":
                    return productB.title.localeCompare(productA.title);
                case "price-ascending":
                    return productA.price - productB.price;
                case "price-descending":
                    return productB.price - productA.price;
                case "created-ascending":
                    return productA.createdAt - productB.createdAt;
                case "created-descending":
                    return productB.createdAt - productA.createdAt;
                default:
                    return productA.featuredOrder - productB.featuredOrder
            }
        }), sorted
    }
    renderProducts(products) {
        this.filteredProducts = products;
        const visibleProducts = products.slice(0, this.visibleCount);
        this.productGrid && (this.productGrid.innerHTML = visibleProducts.length ? visibleProducts.map(product => this.renderProductCard(product)).join("") : '<li class="collection-empty-message">No products found.</li>'), this.renderPagination(products.length)
    }
    renderPagination(totalProducts) {
        if (!this.pagination) return;
        const hasMoreProducts = totalProducts > this.visibleCount;
        this.pagination.innerHTML = hasMoreProducts ? '<button type="button" class="button button--blue-fill product-grid--load-more" data-fallback-load-more>Load more</button>' : "";
        this.pagination.style.display = hasMoreProducts ? "" : "none"
    }
    getPageSize() {
        const productGrid = document.getElementById("product-grid");
        const className = productGrid ? productGrid.className : "";
        const desktopColumnsMatch = className.match(/grid--(\d)-col-desktop/);
        const desktopColumns = desktopColumnsMatch ? parseInt(desktopColumnsMatch[1], 10) : 4;
        return desktopColumns * 3
    }
    renderProductCard(product) {
        const strengthMarkup = product.variantStrengths.map(strengthLabel => {
                const tierClass = this.mapStrengthTier(strengthLabel) ? this.mapStrengthTier(strengthLabel).toLowerCase().replace(/\s+/g, "-") : "";
                return `<div class="card-product--variants-title ${tierClass}"><span class="v-title">${this.escapeHtml(strengthLabel.replace(/mg/gi, "").trim())}</span><span class="mg">MG</span></div>`
            }).join(""),
            offerLabelMarkup = product.labelText ? `<span class="label--offer ${this.escapeHtml(product.labelClass)}">${this.escapeHtml(product.labelText)}</span>` : "",
            priceText = this.moneyFormatter.format(product.price || 0);
        return `<div class="card-product"><div class="card-product--info">${offerLabelMarkup}<a href="${product.url}" class="card-product--link"><span class="card-product--image">${product.image ? `<img src="${product.image}" alt="${this.escapeHtml(product.title)}" width="300" height="300" loading="lazy">` : ""}</span><span class="card-product--vendor">${this.escapeHtml(product.vendor)}</span><span class="card-product--flavour">${this.escapeHtml(product.title)}</span></a></div><div class="card-product--variants">${strengthMarkup}</div><div class="card-product--info-toggle"><a href="${product.url}" class="button button--blue-fill">View Product<span class="icon-chevron"></span></a></div><p class="card-product--pack-saving">${priceText} each</p></div>`
    }
    updateCounts(count) {
        this.desktopCounts.forEach(node => {
            node.textContent = node.closest(".facets__heading") ? `(${count} products)` : `${count} products`
        }), this.mobileCounts.forEach(node => {
            node.textContent = `(${count} products)`
        })
    }
    updateSummaryStates() {
        const labels = {
            brand: "Brand",
            flavour: "Flavour",
            strength: "Strength",
            type: "Type"
        };
        Object.keys(labels).forEach(key => {
            const selectedCount = this.state[key].length;
            this.headers[key] && (this.headers[key].textContent = `${selectedCount} selected`), this.summaries[key] && this.summaries[key].setAttribute("aria-label", `${labels[key]} (${selectedCount} selected)`)
        })
    }
    updateUrl(replaceState = !1) {
        const params = new URLSearchParams;
        this.state.brand.forEach(value => params.append("pf_brand", value)), this.state.flavour.forEach(value => params.append("pf_flavour", value)), this.state.strength.forEach(value => params.append("pf_strength", value)), this.state.type.forEach(value => params.append("pf_type", value)), this.state.sortBy && params.set("sort_by", this.state.sortBy);
        const url = `${this.collectionUrl}${params.toString() ? `?${params.toString()}` : ""}`;
        replaceState ? history.replaceState({}, "", url) : history.pushState({}, "", url)
    }
    buildTypeOptions() {
        const preferredOrder = ["Nicotine Pouches", "Caffeine Pouches", "Nicotine Strips", "Nicotine Toothpicks"],
            uniqueTypes = Array.from(new Set(this.products.map(product => product.productType).filter(Boolean)));
        return preferredOrder.filter(type => uniqueTypes.includes(type)).concat(uniqueTypes.filter(type => !preferredOrder.includes(type)).sort((typeA, typeB) => typeA.localeCompare(typeB)))
    }
    extractFlavour(product) {
        const cleanedTitle = `${product.title || ""} ${(product.tags || []).join(" ")} ${(product.handle || "").replace(/-/g, " ")}`.toLowerCase().replace(/&/g, " ").replace(/[^a-z0-9]+/g, " ");
        return CollectionFallbackFilters.sortedFlavourOptions.find(flavour => cleanedTitle.includes(CollectionFallbackFilters.normalize(flavour))) || ""
    }
    extractStrengthLabel(value) {
        const match = String(value || "").match(/(\d+(?:\.\d+)?)\s*mg/i);
        return match ? `${match[1]}mg` : ""
    }
    normalizeTags(tags) {
        return Array.isArray(tags) ? tags.map(tag => String(tag || "").trim()).filter(Boolean) : String(tags || "").split(",").map(tag => tag.trim()).filter(Boolean)
    }
    resolveOfferLabel(tags) {
        const normalizedTags = tags.map(tag => tag.toLowerCase());
        if (normalizedTags.includes("label-offer--premium-mix") || normalizedTags.includes("premium-mix")) return {
            className: "label-premium-mix",
            text: "Premium Mix"
        };
        if (normalizedTags.includes("label-offer--mix-match") || normalizedTags.includes("mix-match")) return {
            className: "label-mix-match",
            text: "Mix & Match"
        };
        return {
            className: "",
            text: ""
        }
    }
    mapStrengthTier(value) {
        const strengthLabel = this.extractStrengthLabel(value),
            strengthValue = parseFloat(strengthLabel);
        return isNaN(strengthValue) ? "" : strengthValue <= 6 ? "Low" : strengthValue <= 11 ? "Medium" : strengthValue <= 17 ? "High" : strengthValue <= 30 ? "Strong" : "Extra Strong"
    }
    escapeHtml(value) {
        return String(value || "").replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    }
}
CollectionFallbackFilters.normalize = value => String(value || "").toLowerCase().replace(/&/g, " ").replace(/[^a-z0-9]+/g, " ").trim();
CollectionFallbackFilters.brandOptions = ["Killa", "Pablo", "CUBA", "Iceberg", "Lost Mary", "Siberia", "White Fox", "77", "Clew", "DOPE", "ELF", "FUMI", "Helwit", "Maggie", "Nordic Spirit", "Pouch Nurdz", "Rush", "VELO", "XQS", "ZYN"];
CollectionFallbackFilters.flavourOptions = ["All White", "Apple", "Apple Mint", "Araska", "Arctic Berry", "Arctic Mint", "Banana", "Berries", "Berry", "Black Cherry", "Black Tea", "Black Tight", "Blackberry", "Blackcurrant", "Blue Raspberry", "Blueberry", "Blueberry Cranberry Cherry", "Blueberry Ice", "Blueberry Peach Ice", "Bubblegum", "Cappuccino", "Cheesecake", "Cherry", "Cherry Cola", "Chocolate", "Citrus", "Coconut", "Coffee", "Cola", "Cola Cherry", "Cola Vanilla", "Cool", "Cool Mint", "Dark Cherry", "Double Fresh", "Double Mint Tight", "Emerald", "Energy Drinks", "Fiery Mango", "Fizzy", "Flame", "Forest Berries", "Forest Fruits", "Freezing", "Fresh Mint", "Fruit", "Fruit Punch", "Fruity", "Full Charge", "Ghost Original", "Grape", "Grape Ice", "Green Tea", "Guava", "Gum", "Ice", "Ice Mint", "Icy Blackcurrant", "Icy Mint", "Jalapeno", "Jamaican Kola", "Jogurt", "Kiwi", "Lemon", "Lemonade", "Lime", "Liquorice", "Lollipop", "Lychee", "Mango", "Melon", "Melon Mint", "Menthol", "Mint", "Minty Blueberry", "Mixed Berries", "Mocca", "Mr Blue", "Orange", "Papaya", "Passion Fruit", "Passionfruit", "Peach", "Peach Ice", "Peach Mint", "Pear", "Peppermint", "Pinacolada", "Pineapple", "Pink Lemonade", "Pink Punch", "Plantain", "Pomegranate", "Prickly Pear", "Raspberry", "Spearmint", "Strawberry", "Sweet", "Tropical", "Watermelon"];
CollectionFallbackFilters.sortedFlavourOptions = [...CollectionFallbackFilters.flavourOptions].sort((optionA, optionB) => CollectionFallbackFilters.normalize(optionB).length - CollectionFallbackFilters.normalize(optionA).length);
CollectionFallbackFilters.strengthOptions = ["Low", "Medium", "High", "Strong", "Extra Strong"];
